import { Box, Stack, Typography, styled } from "@mui/material";
import NoDataIcon from "../common/NoDataIcon";

const EmptyMessages = ({ children }: { children: string }) => {
    const StyledGridOverlay = styled(Stack)(() => ({
        height: "200px",
    }));

    return (
        <Box
            sx={{
                display: "flex",
                flexGrow: 1,
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
            }}
        >
            <StyledGridOverlay
                alignItems="center"
                justifyContent="center"
                spacing={1}
            >
                <NoDataIcon />
                <Typography align="center" color="#ccc">
                    {children}
                </Typography>
            </StyledGridOverlay>
        </Box>
    );
};

export default EmptyMessages;
